// extracted by mini-css-extract-plugin
export default {"dateRow":"WorkForm_dateRow__YDTt-","dateLabel":"WorkForm_dateLabel__3LM7A","dateInput":"WorkForm_dateInput__mdFUI"};